import { render, staticRenderFns } from "./smsMessageDetail.vue?vue&type=template&id=23e25667"
import script from "./smsMessageDetail.vue?vue&type=script&lang=js"
export * from "./smsMessageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports